import React, { useState, useEffect } from 'react';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import HelmetComponent from '@/components/general/Helmet/HelmetComponent';
import Label from '@/components/form/Label/Label';
import DetallesCitaMedicaModal from '@/components/pages/DatingHistory/modals/DetallesCitaMedicaModal';
import DetalleAnularCitaMedicaModal from '@/components/pages/DatingHistory/modals/DetalleAnularCitaMedicaModal';
import DetalleReasignarCitaMedicaModal from '@/components/pages/DatingHistory/modals/DetalleReasignarCitaMedicaModal';
import DetalleReasignarMedicoCitaMedicoModal from '@/components/pages/DatingHistory/modals/DetalleReasignarMedicoCitaMedicoModal';
import DetalleReasignarHorarioCitaMedicaModal from '@/components/pages/DatingHistory/modals/DetalleReasignarHorarioCitaMedicaModal';
import DetalleReasignarHorario2CitaMedicaModal from '@/components/pages/DatingHistory/modals/DetalleReasignarHorario2CitaMedicaModal';

const DatingHistoryView = (props) => {
  const { reportData, saveMedicalHistory } = props;
  const [selectedPatient, setSelectedPatient] = useState('TODOS');
  const [activeTab, setActiveTab] = useState('historial');
  const [openDetailsModal, setOpenDetailsModal] = useState(false);
  const [openAnular, setOpenAnular] = useState(false);
  const [openReschedule, setOpenReschedule] = useState(false);
  const [openRescheduleMedic, setOpenRescheduleMedic] = useState(false);
  const [openRescheduleDate, setOpenRescheduleDate] = useState(false);
  const [openRescheduleDate2, setOpenRescheduleDate2] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const historiasMedicas = reportData || [];
  const authData = JSON.parse(localStorage.getItem('auth_data'));
  const pacienteNombre = authData?.paciente
    ? `${authData.paciente.nombres || ''} ${authData.paciente.apellido_paterno || ''} ${
        authData.paciente.apellido_materno || ''
      }`.trim()
    : '—';
  const formatDateCard = (fecha, hora) => {
    if (!fecha) {
      return { day: '--', month: '--', weekday: '--', hour: '--:--' };
    }
    const date = new Date(`${fecha} ${hora || '00:00:00'}`);
    return {
      day: String(date.getDate()).padStart(2, '0'),
      month: date.toLocaleString('es-PE', { month: 'short' }).replace('.', '').toUpperCase(),
      weekday: date.toLocaleString('es-PE', { weekday: 'short' }).replace('.', '').toUpperCase(),
      hour: hora ? hora.slice(0, 5) : '--:--',
    };
  };

  return (
    <>
      <DetallesCitaMedicaModal
        open={openDetailsModal}
        onClose={() => setOpenDetailsModal(false)}
        onOpenCancelModal={() => setOpenAnular(true)}
        onOpenRescheduleModal={() => setOpenReschedule(true)}
        reportData={selectedReport}
        saveMedicalHistory={saveMedicalHistory}
      />
      <DetalleAnularCitaMedicaModal open={openAnular} onClose={() => setOpenAnular(false)} />
      <DetalleReasignarCitaMedicaModal
        open={openReschedule}
        onClose={() => setOpenReschedule(false)}
        onOpenReasignarMedicoModal={() => setOpenRescheduleMedic(true)}
        openRescheduleDate={() => setOpenRescheduleDate(true)}
        openRescheduleDate2={() => setOpenRescheduleDate2(true)}
      />
      <DetalleReasignarMedicoCitaMedicoModal
        //doctors={doctors}
        open={openRescheduleMedic}
        onClose={() => setOpenRescheduleMedic(false)}
      />
      <DetalleReasignarHorarioCitaMedicaModal
        open={openRescheduleDate}
        onClose={() => {
          setOpenRescheduleDate(false);
        }}
      />
      <DetalleReasignarHorario2CitaMedicaModal
        open={openRescheduleDate2}
        onClose={() => {
          setOpenRescheduleDate2(false);
        }}
      />
      <div
        className="App bgGradientBlueReverse padt100 m-padt80"
        style={{
          minHeight: '100vh',
          backgroundSize: '500px',
          backgroundRepeat: 'repeat',
          backgroundPosition: 'top left',
        }}
      >
        <HelmetComponent title="Historial de Citas" />
        <FlexContainer
          className="flex-column width100 padtb40 padlr40 align-center bgWhite borderrad20 m-format70"
          style={{ maxWidth: 1100, margin: '0 auto', position: 'relative' }}
        >
          <FlexContainer className="flex-row justify-between width100 align-center">
            <Label className="text-32 fontBold" style={{ color: '#023B7A', marginBottom: 20 }}>
              <strong>Historial de Citas</strong>
            </Label>
            <FlexContainer className="flex-row align-center padt10">
              <FlexContainer className="flex-row align-center">
                <div
                  style={{
                    width: 34,
                    height: 34,
                    background: '#6f8ec0',
                    marginRight: 10,
                  }}
                />
                <Label className="text-16 fontBold padt8" style={{ color: '#023B7A' }}>
                  <strong>Cita Médica</strong>
                </Label>
              </FlexContainer>
            </FlexContainer>
          </FlexContainer>
          {/* TABS */}
          <FlexContainer className="flex-row width100 margt10">
            <FlexContainer
              className="flex-1 justify-center pointer padtb6"
              style={{
                borderBottom: activeTab === 'programadas' ? '3px solid #023B7A' : '1px solid #ccc',
              }}
              onClick={() => setActiveTab('programadas')}
            >
              <Label
                className="text-16 fontBold"
                style={{
                  color: activeTab === 'programadas' ? '#023B7A' : '#888',
                }}
              >
                <strong> Programadas</strong>
              </Label>
            </FlexContainer>
            <FlexContainer
              className="flex-1 justify-center pointer padtb6"
              style={{
                borderBottom: activeTab === 'historial' ? '3px solid #023B7A' : '1px solid #ccc',
              }}
              onClick={() => setActiveTab('historial')}
            >
              <Label
                className="text-16 fontBold"
                style={{
                  color: activeTab === 'historial' ? '#023B7A' : '#888',
                }}
              >
                <strong> Historial</strong>
              </Label>
            </FlexContainer>
          </FlexContainer>

          {activeTab === 'historial' && (
            <FlexContainer className="flex-row gap-20 width100 wrap justify-center margt40">
              <FlexContainer
                className="flex-row justify-between gap-20 width100 padlr10 padtb10"
                style={{
                  flexWrap: 'wrap',
                  alignItems: 'flex-start',
                  maxHeight: 600,
                  overflowY: 'auto',
                  position: 'relative',
                  minHeight: 300,
                  position: 'relative',
                }}
              >
                {loading && (
                  <div
                    className="borderrad10 "
                    style={{
                      position: 'absolute',
                      inset: 0,
                      zIndex: 10,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      backgroundColor: 'rgba(255,255,255,0.6)',
                    }}
                  >
                    <div className="spinner" />
                  </div>
                )}

                {!loading &&
                  historiasMedicas.filter((item) => item.tipo_de_estado?.estado !== 'POR ATENDER')
                    .length === 0 && (
                    <Label className="text-20" style={{ color: '#6b6b6b' }}>
                      No tienes citas registradas en el historial
                    </Label>
                  )}

                {historiasMedicas
                  .filter((item) => item.tipo_de_estado?.estado !== 'POR ATENDER')
                  .map((item) => {
                    const a = formatDateCard(item.fecha_de_atencion, item.hora_de_atencion);

                    return (
                      <FlexContainer
                        key={item.codigo}
                        className="flex-column borderrad20 bgWhite format48 m-format100"
                        style={{
                          //width: '48%',
                          padding: 0,
                          overflow: 'hidden',
                          boxShadow: '0 6px 20px rgba(0,0,0,0.20)',
                        }}
                      >
                        <div style={{ padding: 20, position: 'relative' }}>
                          <FlexContainer className="flex-row gap-10 align-center">
                            <FlexContainer
                              className="flex-column align-center justify-center align-items-center"
                              style={{
                                background: '#023B7A',
                                padding: '8px 6px',
                                position: 'absolute',
                                top: 0,
                                borderRadius: '0px 0px 6px 6px',
                                color: 'white',
                                minWidth: 60,
                              }}
                            >
                              <Label className="text-11 fontBold">{a.weekday}</Label>
                              <Label className="text-22 fontBold">
                                <strong>{a.day}</strong>
                              </Label>
                              <Label className="text-14 fontSemiBold">
                                <strong>{a.month}</strong>
                              </Label>
                              <div
                                style={{
                                  width: '70%',
                                  height: 1,
                                  background: 'rgba(255,255,255,0.5)',
                                  margin: '2px 0',
                                }}
                              />
                              <Label className="text-12 fontSemiBold">{a.hour}</Label>
                            </FlexContainer>
                          </FlexContainer>

                          <FlexContainer className="flex-column margt12 padl90">
                            <Label className="text-16 fontBold" style={{ color: '#023B7A' }}>
                              <strong>
                                {item.personal?.abreviatura || '—'}
                                {item.personal?.nombres || '—'}
                              </strong>
                            </Label>
                            <Label className="text-12" style={{ color: '#6b6b6b' }}>
                              {item.personal?.especialidad || '—'}
                            </Label>
                            <Label className="text-12 margt10 fontBold">
                              <strong>
                                Paciente:{' '}
                                {item.paciente?.nombres +
                                  ' ' +
                                  item.paciente?.apellido_paterno +
                                  ' ' +
                                  item.paciente?.apellido_materno}
                              </strong>
                            </Label>
                            <Label className="text-12 margt2" style={{ color: '#eebb58' }}>
                              {item.tipo_de_estado?.estado || '—'}
                            </Label>
                          </FlexContainer>
                        </div>

                        <div style={{ height: 1, background: '#E5E5E5' }} />
                        <div
                          style={{
                            width: '100%',
                            height: 1,
                            marginTop: 40,
                            background: '#E5E5E5',
                          }}
                        />

                        <FlexContainer className="padtb20 padlr80">
                          <button
                            className="width100 padtb10 borderrad10"
                            onClick={() => {
                              setSelectedReport(item);
                              setOpenDetailsModal(true);
                            }}
                            style={{
                              border: '1px solid #023B7A',
                              color: '#023B7A',
                              background: '#fff',
                              fontWeight: 600,
                            }}
                          >
                            Ver detalles de la cita
                          </button>
                        </FlexContainer>
                      </FlexContainer>
                    );
                  })}
              </FlexContainer>
            </FlexContainer>
          )}

          {activeTab === 'programadas' && (
            <FlexContainer className="flex-row gap-20 width100 wrap justify-center margt40">
              <FlexContainer
                className="flex-row justify-between gap-20 width100 padlr10 padtb10"
                style={{
                  flexWrap: 'wrap',
                  alignItems: 'flex-start',
                  maxHeight: 600,
                  overflowY: 'auto',
                  minHeight: 300,
                  position: 'relative',
                }}
              >
                {loading && (
                  <div
                    className="borderrad10 height-328px"
                    style={{
                      position: 'absolute',
                      inset: 0,
                      zIndex: 10,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      backgroundColor: 'rgba(255,255,255,0.6)',
                    }}
                  >
                    <div className="spinner" />
                  </div>
                )}

                {!loading &&
                  historiasMedicas.filter((item) => item.tipo_de_estado?.estado === 'POR ATENDER')
                    .length === 0 && (
                    <Label className="text-20" style={{ color: '#6b6b6b' }}>
                      No tienes citas programadas
                    </Label>
                  )}

                {!loading &&
                  historiasMedicas
                    .filter((item) => item.tipo_de_estado?.estado === 'POR ATENDER')
                    .map((item) => {
                      const a = formatDateCard(item.fecha_de_atencion, item.hora_de_atencion);

                      return (
                        <FlexContainer
                          key={item.codigo}
                          className="flex-column borderrad20 bgWhite format48 m-format100"
                          style={{
                            //width: '48%',
                            padding: 0,
                            overflow: 'hidden',
                            boxShadow: '0 6px 20px rgba(0,0,0,0.20)',
                          }}
                        >
                          <div style={{ padding: 20, position: 'relative' }}>
                            <FlexContainer className="flex-row gap-10 align-center">
                              <FlexContainer
                                className="flex-column align-center justify-center align-items-center"
                                style={{
                                  background: '#023B7A',
                                  padding: '8px 6px',
                                  position: 'absolute',
                                  top: 0,
                                  borderRadius: '0px 0px 6px 6px',
                                  color: 'white',
                                  minWidth: 60,
                                }}
                              >
                                <Label className="text-11 fontBold">{a.weekday}</Label>
                                <Label className="text-22 fontBold">
                                  <strong>{a.day}</strong>
                                </Label>
                                <Label className="text-14 fontSemiBold">
                                  <strong>{a.month}</strong>
                                </Label>
                                <div
                                  style={{
                                    width: '70%',
                                    height: 1,
                                    background: 'rgba(255,255,255,0.5)',
                                    margin: '2px 0',
                                  }}
                                />
                                <Label className="text-12 fontSemiBold">{a.hour}</Label>
                              </FlexContainer>
                            </FlexContainer>

                            <FlexContainer className="flex-column margt12 padl90">
                              <Label className="text-16 fontBold" style={{ color: '#023B7A' }}>
                                <strong>
                                  {item.personal?.abreviatura || '—'}
                                  {item.personal?.nombres || '—'}
                                </strong>
                              </Label>

                              <Label className="text-12" style={{ color: '#6b6b6b' }}>
                                {item.personal?.especialidad || '—'}
                              </Label>

                              <Label className="text-12 margt10 fontBold">
                                <strong>
                                  Paciente:{' '}
                                  {item.paciente?.nombres +
                                    ' ' +
                                    item.paciente?.apellido_paterno +
                                    ' ' +
                                    item.paciente?.apellido_materno}
                                </strong>
                              </Label>

                              <Label className="text-12 margt2" style={{ color: '#eebb58' }}>
                                {item.tipo_de_estado?.estado || '—'}
                              </Label>
                            </FlexContainer>
                          </div>

                          <div style={{ height: 1, background: '#E5E5E5' }} />
                          <div
                            style={{
                              width: '100%',
                              height: 1,
                              marginTop: 40,
                              background: '#E5E5E5',
                            }}
                          />

                          <FlexContainer className="padtb20 padlr80">
                            <button
                              className="width100 padtb10 borderrad10"
                              onClick={() => {
                                setSelectedReport(item);
                                setOpenDetailsModal(true);
                              }}
                              style={{
                                border: '1px solid #023B7A',
                                color: '#023B7A',
                                background: '#fff',
                                fontWeight: 600,
                              }}
                            >
                              Ver detalles de la cita
                            </button>
                          </FlexContainer>
                        </FlexContainer>
                      );
                    })}
              </FlexContainer>
            </FlexContainer>
          )}
        </FlexContainer>
      </div>
    </>
  );
};
export default DatingHistoryView;
